import React from 'react';
import styles from "./style.module.scss";
import TickIcon from "../../../shared/icons/TickIcon";
import NotVerifiedIcon from "../../../shared/icons/NotVerifiedIcon";
import {File} from "../../../../services";
import { t } from "i18next";

const ProfileDocuments = ({user, onOpenModal, openDocument}) => {
    return (
        <div className={styles['profile__documents']}>
            <div className={styles['profile__documents-title']}>{t("documents.title")}</div>
            <hr className={styles['profile__documents-hr']}></hr>
            <div className={styles['profile__documents-details']}>
                <div className={styles['profile__documents-subtitle']} onClick={() => openDocument('0')}>{t("documents.registrationCertificate")}</div>
                {user && user.state === "Confirmed" ?
                    <div className={styles['profile__documents-img']}><TickIcon /></div>
                    : (
                        <div className={styles['profile__documents-img']}><NotVerifiedIcon /></div>
                    )
                }
            </div>
            <div className={styles['profile__documents-details']}>
                <div className={styles['profile__documents-subtitle']} onClick={() => openDocument('2')} >{t("documents.appointmentOrder")}</div>
                {user && user.state === "Confirmed" ?
                    <div className={styles['profile__documents-img']}><TickIcon /></div>
                    : (
                        <div className={styles['profile__documents-img']}><NotVerifiedIcon /></div>
                    )
                }
            </div>
            {/* {user && user.state === "Confirmed" ?
                null
                : (
                    <button className={styles['profile__documents-btn']} onClick={() => onOpenModal()}>{t("documents.uploadButton")}</button>
                )
            } */}
        </div>
    );
};

export default ProfileDocuments;